import { z } from "zod";

const UpdateBrandUserStatusSchema = z.object({
  brandId: z.number().int().positive(),
  brandUserId: z.number().int().positive(),
  isActive: z.boolean(),
});

export type UpdateBrandUserStatusDTOShape = z.infer<
  typeof UpdateBrandUserStatusSchema
>;

export class UpdateBrandUserStatusDTO {
  readonly brandId!: number;
  readonly brandUserId!: number;
  readonly isActive!: boolean;

  constructor(data: UpdateBrandUserStatusDTOShape) {
    const validated = UpdateBrandUserStatusSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return UpdateBrandUserStatusSchema.safeParse(data);
  }
}

